import React from 'react';
import './ClubJoueur.css';
import fiche from '../assets/fiche.png';
import { useNavigate } from 'react-router-dom';


function ClubJoueur({championnat, player, withInfo = true}) {
    const navigate = useNavigate();

    const calculateAge = () => {
        var today = new Date();
        var birthDate = new Date(player.birthday);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age || 0;
    }

    return (
        <div className="club_joueur_component">
            <div className="joueur_photo_container">
                <img 
                    src={process.env.PUBLIC_URL + "/images/players/" + player.joueur.toUpperCase() + ".png"} 
                    alt="" 
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; 
                        currentTarget.src=process.env.PUBLIC_URL + "/images/players/avatar.png";
                    }}
                />
            </div>
            {
                withInfo && 
                <div className="joueur_information" style={{position: 'relative'}}>
                    <h3>{player.joueur}</h3>
                    <span>Âge : {calculateAge() !== 0 ? calculateAge() : '' }</span>
                    <span>Nationalité : {player.nationalite}</span>
                    {/* <span>{player.style}</span> */}
                    <span>Classement FFTT : {player.classement}</span>
                    <span>Classement Mondial : {player.classement_mondial}</span>
                    <img src={fiche} alt="" className="joueur_fiche" width="64" height="64" onClick={()=>navigate('/performances',{state:{player: player, championnat: championnat}})}/>
                </div>
            }
        </div>
    );
}

export default ClubJoueur;